/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntitySurfaceAssets
 */
export interface ControlEntitySurfaceAssets {
    /**
     * 
     * @type {number}
     * @memberof ControlEntitySurfaceAssets
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntitySurfaceAssets
     */
    domains?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntitySurfaceAssets
     */
    ips?: number;
}

/**
 * Check if a given object implements the ControlEntitySurfaceAssets interface.
 */
export function instanceOfControlEntitySurfaceAssets(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntitySurfaceAssetsFromJSON(json: any): ControlEntitySurfaceAssets {
    return ControlEntitySurfaceAssetsFromJSONTyped(json, false);
}

export function ControlEntitySurfaceAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntitySurfaceAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'ips': !exists(json, 'ips') ? undefined : json['ips'],
    };
}

export function ControlEntitySurfaceAssetsToJSON(value?: ControlEntitySurfaceAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'domains': value.domains,
        'ips': value.ips,
    };
}

